<template>
  <div class="">
    <div class="tinyModal">
      <div class="xBtn" @click.prevent="hidetinyModal">
        <font-awesome-icon icon="times-circle" />
      </div>
      <div class="slider">
        <!-- <i class="fa-solid fa-angles-left fa-2x previous"></i> -->
        <font-awesome-icon icon="angle-left" class="previous fa-solid fa-2x" />

        <div class="img-container">
          <div v-for="item in this.myData" :key="item.slug" class="imgCon">
            <router-link
              :to="{ name: 'detail', params: { id: item.slug } }"
              class="swiper-item__link"
            >
              <img
                class="quickviwe"
                style="width: 350px; height: 250px; object-fit: contain"
                :src="item.image"
                :alt="item.slug"
              />
              <!-- <p class="titleP">{{ item.slug }}</p> -->
            </router-link>
          </div>
          <!-- <img src="https://picsum.photos/id/137/800/500.jpg" alt="" />
          <img src="https://picsum.photos/id/127/800/500.jpg" alt="" />
          <img src="https://picsum.photos/id/300/800/500.jpg" alt="" />
          <img
            src="https://picsum.photos/id/1008/800/500.jpg?hmac=906z84ml4jhqPMsm4ObF9aZhCRC-t2S_Sy0RLvYWZwY"
            alt=""
          /> -->
        </div>
        <!-- <i class="fa-solid fa-angles fa-2x next"></i> -->
        <font-awesome-icon icon="angle-right" class="next fa-solid fa-2x" />
      </div>
    </div>

    <a @click.prevent="showtinyModal" class="btn gbtn" href="#">
      <font-awesome-icon icon="photo-video" />
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      myData: null,
    };
  },
  methods: {
    hidetinyModal() {
      var tinyModal = document.getElementsByClassName("tinyModal")[0];
      var btn = document.getElementsByClassName("gbtn")[0];
      tinyModal.style.bottom = "-300px";
      btn.style.opacity = "1";
    },
    showtinyModal() {
      var tinyModal = document.getElementsByClassName("tinyModal")[0];
      var btn = document.getElementsByClassName("gbtn")[0];
      console.log(btn);

      tinyModal.style.bottom = "20px";
      btn.style.opacity = "0";
    },
  },

  mounted() {
    const next = document.querySelector(".next");
    const prev = document.querySelector(".previous");

    let numImg = document.querySelectorAll(".quickviwe").length;
    let currImg = 1;

    let timeoutID;

    next.addEventListener("click", () => {
      currImg++;
      clearTimeout(timeoutID);
      updateImage();
    });

    prev.addEventListener("click", () => {
      currImg--;
      clearTimeout(timeoutID);

      updateImage();
    });

    const imgcontainer = document.querySelector(".img-container");

    function updateImage() {
      numImg = document.querySelectorAll(".quickviwe").length;
      console.log(currImg);
      if (currImg > numImg) {
        currImg = 1;
      } else if (currImg < 1) {
        currImg = numImg;
      }
      imgcontainer.style.transform = `translateX(-${(currImg - 1) * 350}px)`;

      timeoutID = setTimeout(() => {
        currImg++;
        updateImage();
      }, 2000);
    }

    updateImage();
  },

  components: {},
  created() {
    var that = this;
    this.$store.state.load = true;
    $.ajax({
      url: that.$store.state.url + "api/v1/products/quick_view/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        console.log(data);
        that.myData = data;
        this.$store.state.load = false;
      },
      error: function (request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
        this.$store.state.load = false;
      },
      complete: function () {
        this.$store.state.load = false;
      },
    });
    this.$store.state.load = false;
  },
};
</script>

<style lang="scss" scoped>
.tinyModal {
  width: 350px;
  height: 250px;
  overflow: hidden;
  background: #ffffff;
  position: fixed;
  bottom: 20px;
  left: 20px;
  transition: 1s;
  z-index: 50000000000000;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.432);
  @media screen and (max-width: 800px) {
    // width: 100%;
    display: none;
  }
}
.xBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  z-index: 55;
  svg {
    color: red;
    font-size: 2em;
  }
}
.titleP {
  color: black;
  position: absolute;
  bottom: 0;
}
.hide {
  position: absolute;
  z-index: 9999;
  top: 14px;
  right: 14px;
  font-size: 20px;
  color: white;
  opacity: 0.7;
  transition: 0.3s;
  cursor: pointer;
}

.imgCon {
  width: 100%;
  height: 100%;
}
.hide:hover {
  transform: rotate(90deg);
  opacity: 1;
}

.btn {
  color: var(--sub-color);
  position: fixed;
  bottom: 1%;
  left: 1%;
  //   transform: translate(-50%, -50%);
  border-radius: 8px;
  border: 2px solid;
  padding: 10px 20px;
  z-index: 5000;
  width: 50px;
  background: white;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 800px) {
    // width: 100%;
    display: none;
  }
}

.slider {
  width: 100%;
  height: 100%;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
}

.img-container {
  width: 100%;
  height: 100%;
  display: flex;
  transition: transform 300ms ease-in-out;
}

.fa-solid {
  cursor: pointer;
  color: white;
  position: absolute;
  opacity: 0.75;
  transition: opacity 100ms ease-in-out;
  z-index: 100;
  background: gray;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.fa-solid:hover {
  opacity: 1;
}

.previous {
  position: absolute;
  bottom: 5%;
  left: 5%;
  //   left: 4.5rem;
}

.next {
  //   right: 4.5rem;
  position: absolute;
  bottom: 5%;
  right: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/tinyModal/tinyModal.vue